// extracted by mini-css-extract-plugin
export default {"signatureContainer":"ProductionStudyReport_signatureContainer__XtBzs","signature":"ProductionStudyReport_signature__A2pNv"};